/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RealmSigninBody
 */
export interface RealmSigninBody {
    /**
     * utm_source from the landing URL.
     * @type {string}
     * @memberof RealmSigninBody
     */
    utmSource?: string;
    /**
     * utm_medium from the landing URL. Resolved ahead of the source for paid values, so omitting it is what turns a paid click into an organic one.
     * @type {string}
     * @memberof RealmSigninBody
     */
    utmMedium?: string;
    /**
     * utm_campaign from the landing URL, stored verbatim.
     * @type {string}
     * @memberof RealmSigninBody
     */
    utmCampaign?: string;
    /**
     * document.referrer at landing. Separates EARNED from DIRECT for an untagged arrival.
     * @type {string}
     * @memberof RealmSigninBody
     */
    referrer?: string;
}

/**
 * Check if a given object implements the RealmSigninBody interface.
 */
export function instanceOfRealmSigninBody(value: object): value is RealmSigninBody {
    return true;
}

export function RealmSigninBodyFromJSON(json: any): RealmSigninBody {
    return RealmSigninBodyFromJSONTyped(json, false);
}

export function RealmSigninBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealmSigninBody {
    if (json == null) {
        return json;
    }
    return {
        
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'utmMedium': json['utmMedium'] == null ? undefined : json['utmMedium'],
        'utmCampaign': json['utmCampaign'] == null ? undefined : json['utmCampaign'],
        'referrer': json['referrer'] == null ? undefined : json['referrer'],
    };
}

export function RealmSigninBodyToJSON(json: any): RealmSigninBody {
    return RealmSigninBodyToJSONTyped(json, false);
}

export function RealmSigninBodyToJSONTyped(value?: RealmSigninBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'utmSource': value['utmSource'],
        'utmMedium': value['utmMedium'],
        'utmCampaign': value['utmCampaign'],
        'referrer': value['referrer'],
    };
}

